export default __webpack_public_path__ + "c0f9dccd4ca01dd0217faf0c84bf79a0.ttf";